import SideBar from "../Components/SideBar";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from "../../Redux/action";
import apiRequest from "../../apiCall";


export default function ShopComment(){
    const [shopCommentData, setShopCommentData] = useState([]);
    useEffect(() => {
        callApi();
      }, []);
    
      const dispatch = useDispatch();
    
      const callApi = async () => {
        try {
          dispatch(setLoading(true));
          apiRequest("GET", "shopcomment", null, true, true).then((res) => {
            dispatch(setLoading(false));
            setShopCommentData(res.data); 
          });
        } catch (error) {
          dispatch(setLoading(false));
          console.error("Error fetching data:", error);
        }
      };
    return(
        <div className="admin-shop-comments">
            <SideBar/>
            <div className='admin-container'>
        <h1>Shop Comments</h1>
        <br />
        <table className='admin-shop-comments-table'>
          <thead>
            <tr>
              <th>User Name</th>
              <th>Product Name</th>
              <th>Review</th>
              <th>Rating</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(shopCommentData) && shopCommentData.length > 0 ? (
              shopCommentData.map((comment) => (
                <tr key={comment.ID}>
                  <td>{comment.FirstName} {comment.LastName}</td>
                  <td>{comment.ProductID}</td>
                  <td>{comment.Review}</td>
                  <td>{comment.Rating}</td>
                  <td>{comment.Date}</td>
                  <td>{comment.Status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No Record Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
        </div>
    );
}